import {
  createAsyncThunk,
  createSlice,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import history from "@history";
import { ApiEmpAdmin, endpoints_empAdmin } from "src/app/api";

const api = new ApiEmpAdmin();

export const getEmpAdmins = createAsyncThunk(
  "empAdminApp/admin/getEmpAdmins",
  async (params, { getState }) => {
    const data = await api.get(endpoints_empAdmin.EMPADMIN);
    return { data };
  }
);

export const getEmpAdmin = createAsyncThunk(
  "empAdminApp/admin/getEmpAdmin",
  async (id, { dispatch, getState }) => {
    try {
      const data = await api.get(endpoints_empAdmin.EMPADMIN, id);
      return { data };
    } catch (error) {
      history.push({ pathname: `/empAdmin` });
      return null;
    }
  }
);

export const addEmpAdmin = createAsyncThunk(
  "empAdminApp/admin/addEmpAdmin",
  async (empAdmin, { dispatch, getState }) => {
    const data = await api.post(endpoints_empAdmin.EMPADMIN, empAdmin);
    return { data };
  }
);

export const updateEmpAdmin = createAsyncThunk(
  "empAdminApp/admin/updateEmpAdmin",
  async (empAdmin, { dispatch, getState }) => {
    const empAdminsArray = getState().empAdminsSlice.entities;

    try {
      const data = await api.put(
        endpoints_empAdmin.EMPADMIN,
        empAdmin.id,
        empAdmin
      );
      return { data };
    } catch (error) {
      return error;
    }
  }
);

export const removeEmpAdmin = createAsyncThunk(
  "empAdminApp/admin/removeEmpAdmin",
  async (empAdmin, { dispatch, getState }) => {
    try {
      const data = {
        id: empAdmin.id,
        name: empAdmin.name,
        active: false,
      };
      const response = await api.put(
        endpoints_empAdmin.EMPADMIN,
        empAdmin.id,
        data
      );
      return response.id;
    } catch (error) {
      return error;
    }
  }
);

const empAdminAdapter = createEntityAdapter();

const empAdminSlice = createSlice({
  name: "empAdminApp/admin",
  initialState: empAdminAdapter.getInitialState({
    selectedUserId: null,
  }),
  reducers: {
    clearSelectedEmpAdmin: (state) => {
      state.selectedEmpAdminId = null;
    },
    setSelectedEmpAdmin: (state, action) => {
      state.selectedEmpAdminId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEmpAdmins.fulfilled, (state, action) => {
        empAdminAdapter.setAll(state, action.payload.data);
      })
      .addCase(addEmpAdmin.fulfilled, (state, action) => {
        empAdminAdapter.addOne(state, action.payload.data);
      })
      .addCase(getEmpAdmin.fulfilled, (state, action) => {
        empAdminAdapter.upsertOne(state, action.payload.data);
      })
      .addCase(removeEmpAdmin.fulfilled, (state, action) => {
        empAdminAdapter.removeOne(state, action.payload.id);
      })
      .addCase(updateEmpAdmin.fulfilled, (state, action) => {
        empAdminAdapter.upsertOne(state, action.payload.data);
      });
  },
});

export const { clearSelectedEmpAdmin, setSelectedEmpAdmin } =
  empAdminSlice.actions;

export const { selectAll: selectEmpAdmin, selectById: selectEmpAdminById } =
  empAdminAdapter.getSelectors((state) => state.empAdminApp.admin);

export const selectSelectedEmpAdmin = (state) => {
  const id = state.empAdminApp.admin.selectedEmpAdminId;
  return id ? selectEmpAdminById(state, id) : null;
};

export default empAdminSlice.reducer;
